import React from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { Navigate, useLocation } from 'react-router';
import { setLoginDestination } from 'auth/store/auth/actions';
import { getIsAuthenticated } from 'auth/store/auth/selectors';

export type ProtectedRouteProps = {
  authenticationPath: string;
  children: JSX.Element;
};

export default function ProtectedRoute({ authenticationPath, children }: ProtectedRouteProps) {
  const isAuthenticated = useAppSelector(getIsAuthenticated);
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (!isAuthenticated) dispatch(setLoginDestination(pathname));
  }, [pathname, dispatch, isAuthenticated]);

  if (isAuthenticated) {
    return children;
  }

  return <Navigate to={authenticationPath} />;
}
